// src/contexts/UserContext.js
import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api/axios';

const UserContext = createContext();

/** ──────────────────────────────────────────────
 *  UserProvider
 *  - 전역에서 유저 정보를 제공
 *  - refreshUserInfo() 호출 → 사이드바·헤더 등 즉시 갱신
 *  ────────────────────────────────────────────── */
export const UserProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    /** 최신 정보 재요청 (포인트‧칭호 등 바뀔 때마다 호출) */
    const refreshUserInfo = useCallback(() => {
        api.get('/api/user-info/')
            .then(res => setUserInfo(res.data))
            .catch(err => {
                console.error('유저 정보 로딩 실패', err);
                setUserInfo(null);            // 에러 시 안전하게 null
            })
            .finally(() => setLoading(false));
    }, []);

    /* 앱 첫 진입 시 1회 호출 */
    useEffect(() => {
        refreshUserInfo();
    }, [refreshUserInfo]);

    /* 로딩 중에는 간단한 스피너/문구 */
    if (loading) return <div>로딩 중입니다...</div>;

    /* 전역 컨텍스트 값 */
    const value = {
        userInfo,                // 전체 유저 정보 { username, points, ... }
        username: userInfo?.username,
        fetchUserInfo: refreshUserInfo, // ← 옛 이름도 같이 제공 옛이름 바꿔야함함
        refreshUserInfo,         // ✅ 언제든 호출해 최신 상태로 갱신
        setUserInfo,             // 필요 시 직접 수정
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

/** 컨텍스트 훅 */
export const useUser = () => useContext(UserContext);
